import { render, staticRenderFns } from "./CotizacionInmobiliaria.vue?vue&type=template&id=834e3eaa&scoped=true&lang=html&"
import script from "./CotizacionInmobiliaria.vue?vue&type=script&lang=js&"
export * from "./CotizacionInmobiliaria.vue?vue&type=script&lang=js&"
import style0 from "./CotizacionInmobiliaria.vue?vue&type=style&index=0&id=834e3eaa&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "834e3eaa",
  null
  
)

export default component.exports